import React from 'react';
import PropTypes from 'prop-types';

const CollectionText = ({ content }) => {
  if (!content?.text?.data) {
    return null;
  }

  return (
    <div
      className="mb-8 prose prose-sm max-w-none"
      dangerouslySetInnerHTML={{ __html: content.text.data }}
    />
  );
};

CollectionText.propTypes = {
  content: PropTypes.shape({
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
  }),
};

CollectionText.defaultProps = {
  content: null,
};

export default CollectionText;
